export default "__VITE_ASSET__C5tcu9Xo__"